import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
    selector: 'app-password-validator',
    templateUrl: './password-validator.component.html',
    styleUrl: './password-validator.component.scss',
    standalone: false
})
export class PasswordValidatorComponent implements OnInit {
  @Input() passwordControl!: AbstractControl<any>;

	lowerCaseValid = false;
  upperCaseValid = false;
  numberValid = false;
  lengthValid = false;

  ngOnInit(): void {
		this.validatePassword();
		
    this.passwordControl.valueChanges.subscribe(() => {
      this.validatePassword();
    });
  }

  validatePassword(): void {
    if (!this.passwordControl) return;
    const value = this.passwordControl.value;

    const lowerCaseLetters = /[a-z]/g;
    const upperCaseLetters = /[A-Z]/g;
    const numbers = /[0-9]/g;

    this.lowerCaseValid = lowerCaseLetters.test(value);
    this.upperCaseValid = upperCaseLetters.test(value);
    this.numberValid = numbers.test(value);
    this.lengthValid = value.length >= 8;
  }
}
